/**
 * Mo.immo — Main JavaScript
 * =========================================
 */

'use strict';

// ── Cart ──
const MoImmo = {

  init() {
    this.initHeader();
    this.initCart();
    this.initProductForms();
  },

  // Sticky header
  initHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const observer = new IntersectionObserver(
      ([entry]) => header.classList.toggle('is-sticky', !entry.isIntersecting),
      { rootMargin: '-1px 0px 0px 0px', threshold: [1] }
    );

    const sentinel = document.createElement('div');
    document.body.prepend(sentinel);
    observer.observe(sentinel);
  },

  // Cart drawer
  initCart() {
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-cart-toggle]')) {
        document.querySelector('[data-cart-drawer]')?.classList.toggle('is-open');
      }
      if (e.target.matches('[data-cart-close]')) {
        document.querySelector('[data-cart-drawer]')?.classList.remove('is-open');
      }
    });
  },

  // Product form — add to cart via AJAX
  initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const data = new FormData(form);
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: data,
          });
          const item = await res.json();
          if (item.id) {
            document.dispatchEvent(new CustomEvent('cart:add', { detail: item }));
          }
        } catch (err) {
          console.error('Add to cart failed:', err);
        }
      });
    });
  },

};

document.addEventListener('DOMContentLoaded', () => MoImmo.init());
